export default {"id":"4b1f8035","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}